/* Midway product page extras (added by Claude, draft theme):
   low-stock note, "add multiple sizes at once" for team items, mobile sticky Add to cart bar. */
(function () {
  if (window.mwPdpInit) return;
  window.mwPdpInit = true;

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function inDrawer(el) { return !!(el && el.closest('quick-buy-drawer, .quick-buy-drawer')); }

  function variantsFor(formId) {
    var el = document.querySelector('script[data-mw-pdp-variants][data-form="' + formId + '"]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function selectedOptions(formId) {
    var vals = {};
    document.querySelectorAll('input[name^="option"][form="' + formId + '"]').forEach(function (i) {
      if (i.type === 'hidden' || i.checked) vals[i.name] = i.value;
    });
    return vals;
  }

  function currentVariant(formId, variants) {
    var form = document.getElementById(formId);
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(idInput.value)) return variants[i]; }
    }
    var sel = selectedOptions(formId);
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      var ok = v.o.every(function (val, idx) {
        var s = sel['option' + (idx + 1)];
        return s === undefined || s === val;
      });
      if (ok) return v;
    }
    return variants[0];
  }

  /* Low stock */
  function updateLowStock(formId, v) {
    var el = document.querySelector('[data-mw-lowstock][data-form="' + formId + '"]');
    if (!el) return;
    if (v && v.a && v.q !== null && v.q > 0 && v.q <= 5) {
      el.textContent = 'Only ' + v.q + ' left in this size';
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  /* Add multiple sizes at once (team items) */
  function renderBulk(formId, variants, v) {
    var box = document.querySelector('[data-mw-bulk][data-form="' + formId + '"]');
    if (!box || inDrawer(box) || !v) return;
    var sizeIdx = parseInt(box.getAttribute('data-size-pos'), 10) - 1;
    var grid = box.querySelector('[data-mw-bulk-grid]');
    var hint = box.querySelector('[data-mw-bulk-hint]');
    var others = v.o.filter(function (_, i) { return i !== sizeIdx; });
    var key = others.join('|');
    if (grid.getAttribute('data-key') === key) return;
    grid.setAttribute('data-key', key);
    grid.textContent = '';
    hint.textContent = others.length ? 'Enter a quantity for each size in ' + others.join(' / ') + '.' : 'Enter a quantity for each size.';
    variants.forEach(function (x) {
      var same = x.o.every(function (val, i) { return i === sizeIdx || val === v.o[i]; });
      if (!same) return;
      var cell = document.createElement('label');
      cell.className = 'mw-bulk__cell' + (x.a ? '' : ' is-out');
      var name = document.createElement('span');
      name.className = 'mw-bulk__size';
      name.textContent = x.o[sizeIdx];
      var input = document.createElement('input');
      input.type = 'number';
      input.min = '0';
      input.inputMode = 'numeric';
      input.placeholder = '0';
      input.className = 'mw-bulk__qty';
      input.setAttribute('data-id', x.id);
      input.setAttribute('aria-label', 'Quantity for size ' + x.o[sizeIdx]);
      if (x.q !== null) input.max = String(x.q);
      if (!x.a) { input.disabled = true; input.placeholder = '–'; }
      cell.appendChild(name);
      cell.appendChild(input);
      if (x.a && x.q !== null && x.q <= 10) {
        var left = document.createElement('span');
        left.className = 'mw-bulk__left';
        left.textContent = x.q + ' left';
        cell.appendChild(left);
      }
      grid.appendChild(cell);
    });
    updateBulkTotal(box);
  }

  function clampQty(input) {
    var max = input.max ? parseInt(input.max, 10) : 0;
    var n = parseInt(input.value, 10) || 0;
    var box = input.closest('[data-mw-bulk]');
    var msg = box && box.querySelector('[data-mw-bulk-msg]');
    if (input.max && n > max) {
      input.value = String(max);
      if (msg) {
        var size = input.closest('.mw-bulk__cell').querySelector('.mw-bulk__size').textContent;
        msg.textContent = 'Only ' + max + ' available in ' + size + ' right now. Need more? Get a quote below and we will check with the manufacturer.';
      }
    }
  }

  function updateBulkTotal(box) {
    var total = 0;
    var cents = 0;
    var variants = variantsFor(box.getAttribute('data-form'));
    box.querySelectorAll('.mw-bulk__qty').forEach(function (i) {
      var n = parseInt(i.value, 10) || 0;
      if (n > 0) {
        total += n;
        for (var k = 0; k < variants.length; k++) { if (String(variants[k].id) === i.getAttribute('data-id')) cents += variants[k].p * n; }
      }
    });
    box.querySelector('[data-mw-bulk-total]').textContent = total + (total === 1 ? ' item' : ' items') + (total ? ' · ' + money(cents) : '');
    box.querySelector('[data-mw-bulk-add]').disabled = total === 0;
    var moq = box.querySelector('[data-mw-bulk-moq]');
    if (moq) moq.hidden = total < 20;
  }

  function bulkAdd(box) {
    var items = [];
    box.querySelectorAll('.mw-bulk__qty').forEach(function (i) {
      var n = parseInt(i.value, 10) || 0;
      if (n > 0) items.push({ id: parseInt(i.getAttribute('data-id'), 10), quantity: n });
    });
    if (!items.length) return;
    var btn = box.querySelector('[data-mw-bulk-add]');
    var msg = box.querySelector('[data-mw-bulk-msg]');
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    msg.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (res.ok) {
          window.location.href = '/cart';
        } else {
          msg.textContent = ((res.d && (res.d.description || res.d.message)) || 'Some sizes could not be added.') + ' ';
          var a = document.createElement('a');
          a.href = '/cart';
          a.textContent = 'View cart';
          msg.appendChild(a);
          btn.disabled = false;
          btn.textContent = 'Add all to cart';
        }
      })
      .catch(function () {
        msg.textContent = 'Something went wrong. Please try again.';
        btn.disabled = false;
        btn.textContent = 'Add all to cart';
      });
  }

  /* Mobile sticky Add to cart */
  function setupSticky(formId) {
    var bar = document.querySelector('[data-mw-sticky][data-form="' + formId + '"]');
    if (!bar || inDrawer(bar) || bar.getAttribute('data-ready')) return;
    bar.setAttribute('data-ready', '1');
    /* If the theme already shows its own sticky bar, keep that one only */
    if (document.querySelector('product-quick-add, .product-quick-add, product-sticky-bar, .product-sticky-bar')) { bar.remove(); return; }
    document.body.appendChild(bar);
    var form = document.getElementById(formId);
    var target = form && (form.querySelector('buy-buttons') || form);
    if (!target || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
    });
    io.observe(target);
    bar.querySelector('[data-mw-sticky-add]').addEventListener('click', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn && !btn.disabled) {
        btn.click();
      } else {
        var picker = document.querySelector('.product-info__variant-picker') || target;
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  function updateSticky(formId, v) {
    var bar = document.querySelector('[data-mw-sticky][data-form="' + formId + '"]');
    if (!bar || !v) return;
    var meta = bar.querySelector('[data-mw-sticky-meta]');
    meta.textContent = money(v.p) + (v.o.length && v.o[0] !== 'Default Title' ? ' · ' + v.o.join(' / ') : '');
    var btn = bar.querySelector('[data-mw-sticky-add]');
    btn.textContent = v.a ? 'Add to cart' : 'Sold out';
    btn.classList.toggle('is-out', !v.a);
  }

  /* River Landing store availability for the selected color/size */
  function updateStore(formId, v) {
    var row = document.querySelector('[data-mw-store][data-form="' + formId + '"]');
    if (!row || !v || row.getAttribute('data-any') !== 'true') return;
    var text = row.querySelector('[data-mw-store-text]');
    var pickup = (row.getAttribute('data-pickup') || 'today').toLowerCase();
    text.textContent = '';
    if (v.s) {
      var b = document.createElement('strong');
      b.textContent = 'In stock at our River Landing store.';
      text.appendChild(b);
      text.appendChild(document.createTextNode(' Pick up ' + pickup + ': choose Pickup at checkout.'));
    } else {
      text.textContent = (v.o.length > 1 || v.o[0] !== 'Default Title' ? 'This ' + (v.o.length > 1 ? 'size and color isn\u2019t' : 'option isn\u2019t') : 'This item isn\u2019t') + ' in our River Landing store, it ships online only.';
    }
    row.classList.toggle('is-in', !!v.s);
    row.classList.toggle('is-out', !v.s);
  }

  /* Sold-out marking (replaces the theme's rule):
     - Sizes (and any other non-color option) get the theme's crossed-out style when sold out in the
       currently selected color.
     - Colors are never crossed out, so landing on a size like XS never makes colors look sold out.
     The theme's own rule crossed out colors based on the selected size, and never crossed out sizes. */
  function patchVariantPicker() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('variant-picker').then(function () {
      var C = customElements.get('variant-picker');
      if (!C || C.prototype.__mwPatched) return;
      C.prototype.__mwPatched = true;
      C.prototype._updateDisableSelectors = function () {
        var picker = this;
        var selected = picker.selectedVariant;
        if (!selected || !picker.optionSelectors || !picker.product) return;
        var variants = picker.product.variants || [];
        var options = picker.product.options || [];
        var sel = [selected.option1, selected.option2, selected.option3];
        picker.optionSelectors.forEach(function (selector, optIndex) {
          var option = options[optIndex];
          if (!option || !option.values) return;
          var isColor = !!selector.querySelector('.media-swatch, .color-swatch');
          var key = 'option' + (optIndex + 1);
          var nodes = Array.prototype.slice.call(selector.querySelectorAll('[data-option-value]'));
          option.values.forEach(function (value, valueIndex) {
            var node = nodes[valueIndex];
            if (!node) return;
            var exists = variants.some(function (v) { return v[key] === value; });
            var available = isColor ? true : variants.some(function (v) {
              if (v[key] !== value || !v.available) return false;
              for (var k = 0; k < options.length; k++) {
                if (k !== optIndex && v['option' + (k + 1)] !== sel[k]) return false;
              }
              return true;
            });
            node.toggleAttribute('hidden', !exists);
            if (picker.hideSoldOutVariants) {
              node.toggleAttribute('hidden', !exists || !available);
            } else {
              node.classList.toggle('is-disabled', !available);
            }
          });
        });
      };
      document.querySelectorAll('variant-picker').forEach(function (p) {
        if (p.product && p.optionSelectors) { try { p._updateDisableSelectors(); } catch (e) {} }
      });
    });
  }

  /* Picking a color/size or clicking a gallery thumbnail must not jump the page. The theme's slider script runs
     $('html, body').animate({ scrollTop: slider }) on every variant change and thumbnail click; skip just that
     page scroll (the photo still changes). Patches every copy of jQuery on the page. */
  var blockScrollUntil = 0;
  function blockPageScroll(ms) { blockScrollUntil = Date.now() + (ms || 500); }
  window.addEventListener('variant:change', function () { blockPageScroll(600); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.thumbnail-image, .vertical-slider-nav, variant-picker, .variant-picker, product-gallery, .product-gallery')) blockPageScroll(800);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker, .variant-picker')) blockPageScroll(800);
  }, true);
  function patchOne(jq) {
    if (!jq || !jq.fn || !jq.fn.animate || jq.fn.__mwPatched) return;
    jq.fn.__mwPatched = true;
    var original = jq.fn.animate;
    jq.fn.animate = function (props) {
      if (Date.now() < blockScrollUntil && props && typeof props === 'object' &&
          Object.prototype.hasOwnProperty.call(props, 'scrollTop') && this.is && this.is('html, body')) return this;
      return original.apply(this, arguments);
    };
  }
  (function waitForJquery(tries) {
    patchOne(window.jQuery);
    patchOne(window.$);
    if (tries < 40) setTimeout(function () { waitForJquery(tries + 1); }, 250);
  })(0);
  patchVariantPicker();

  function refresh(formId) {
    var variants = variantsFor(formId);
    if (!variants.length) return;
    var v = currentVariant(formId, variants);
    updateLowStock(formId, v);
    updateStore(formId, v);
    renderBulk(formId, variants, v);
    updateSticky(formId, v);
  }

  function init() {
    document.querySelectorAll('script[data-mw-pdp-variants]').forEach(function (s) {
      var formId = s.getAttribute('data-form');
      if (s.getAttribute('data-init')) return;
      s.setAttribute('data-init', '1');
      if (!inDrawer(s)) setupSticky(formId);
      refresh(formId);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.getAttribute) return;
    if (t.classList && t.classList.contains('mw-bulk__qty')) { clampQty(t); updateBulkTotal(t.closest('[data-mw-bulk]')); return; }
    var formId = t.getAttribute('form') || (t.form && t.form.id);
    if (formId) setTimeout(function () { refresh(formId); }, 60);
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('mw-bulk__qty')) { clampQty(t); updateBulkTotal(t.closest('[data-mw-bulk]')); }
  });
  /* Team quote panel */
  var quoteLastFocus = null;
  function bulkSummary(box) {
    if (!box) return '';
    var parts = [];
    box.querySelectorAll('.mw-bulk__qty').forEach(function (i) {
      var n = parseInt(i.value, 10) || 0;
      if (n > 0) parts.push(n + ' ' + i.closest('.mw-bulk__cell').querySelector('.mw-bulk__size').textContent);
    });
    return parts.join(', ');
  }
  function openQuote(trigger) {
    var team = trigger.closest('.mw-team');
    var formId = (team && team.getAttribute('data-form')) || '';
    var panel = document.querySelector('[data-mw-quote][data-form="' + formId + '"]') || document.querySelector('[data-mw-quote]');
    if (!panel) return false;
    if (panel.parentNode !== document.body) document.body.appendChild(panel);
    var variants = variantsFor(formId);
    var v = variants.length ? currentVariant(formId, variants) : null;
    var label = v && v.o[0] !== 'Default Title' ? v.o.join(' / ') : '';
    var vt = panel.querySelector('[data-mw-quote-variant-text]');
    if (vt) vt.textContent = label;
    var vi = panel.querySelector('[data-mw-quote-variant]');
    if (vi) vi.value = label;
    var sizes = panel.querySelector('[data-mw-quote-sizes]');
    var summary = bulkSummary(team && team.querySelector('[data-mw-bulk]'));
    if (sizes && summary && (trigger.hasAttribute('data-mw-quote-with-sizes') || !sizes.value)) sizes.value = summary;
    var bar = document.getElementById('preview-bar-iframe');
    var p = panel.querySelector('.mw-quote__panel');
    if (p && window.matchMedia('(max-width: 699px)').matches) {
      var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      p.style.bottom = h ? h + 'px' : '';
    }
    var qtyInput = panel.querySelector('[data-mw-quote-qty]');
    var bulkBox = team && team.querySelector('[data-mw-bulk]');
    if (qtyInput && bulkBox) {
      var count = 0;
      bulkBox.querySelectorAll('.mw-bulk__qty').forEach(function (i) { count += parseInt(i.value, 10) || 0; });
      if (count > 0 && (!qtyInput.value || trigger.hasAttribute('data-mw-quote-with-sizes'))) qtyInput.value = String(count);
    }
    updateMoq(panel);
    updateQuoteTiming(panel);
    quoteLastFocus = document.activeElement;
    panel.hidden = false;
    document.documentElement.classList.add('mw-quote-open');
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      var first = panel.querySelector('input:not([type="hidden"]), .mw-quote__submit');
      if (first) first.focus({ preventScroll: true });
    });
    return true;
  }
  /* Quote form: decoration chips + earliest realistic "Needed by" date.
     Blank only: ships in 1-2 business days + 2-5 days ground, so earliest = 7 business days out.
     Decorated (or not sure yet): the 10-business-day production clock starts when the order is paid.
     Assume payment within 2 business days, then 10 business days to ship + at least 2 days ground,
     so earliest = 14 business days out. Earlier dates can't be picked; rush requests call us. */
  function addBusinessDays(date, n) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function isoDate(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function niceDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }
  function updateQuoteTiming(panel) {
    var deco = panel.querySelector('[data-mw-deco]');
    var input = panel.querySelector('[data-mw-needby]');
    var note = panel.querySelector('[data-mw-needby-note]');
    if (!deco || !input || !note) return;
    var picked = Array.prototype.slice.call(deco.querySelectorAll('input[type="checkbox"]:checked'));
    var values = picked.map(function (c) { return c.value; });
    var hidden = deco.querySelector('[data-mw-deco-value]');
    if (hidden) hidden.value = values.length ? values.join(', ') : 'Not sure yet';
    var blankOnly = picked.length > 0 && picked.every(function (c) { return c.hasAttribute('data-mw-deco-blank'); });
    var approveBy = addBusinessDays(new Date(), 2);
    var earliest = blankOnly ? addBusinessDays(new Date(), 7) : addBusinessDays(approveBy, 12);
    input.min = isoDate(earliest);
    if (input.value && input.value < input.min) input.value = '';
    note.textContent = '';
    var lead;
    if (blankOnly) {
      lead = 'Blank orders ship in 1\u20132 business days, then 2\u20135 business days for ground delivery. Earliest delivery: ';
    } else {
      lead = 'Decorated orders typically ship within 10 business days after payment, followed by 2\u20135 business days for ground delivery. Pay by ' + niceDate(approveBy) + ' for estimated delivery as early as ';
    }
    note.appendChild(document.createTextNode(lead));
    var b = document.createElement('strong');
    b.textContent = niceDate(earliest) + '.';
    note.appendChild(b);
    if (!blankOnly) note.appendChild(document.createTextNode(' Timing may vary based on artwork approval and revisions to mockups and proofs.'));
    note.appendChild(document.createTextNode(' Need it sooner? Call us at '));
    var a = document.createElement('a');
    a.href = 'tel:+17863532005';
    a.textContent = '(786) 353-2005';
    note.appendChild(a);
    note.appendChild(document.createTextNode('.'));
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    var deco = t && t.closest && t.closest('[data-mw-deco]');
    if (!deco) return;
    if (t.checked && t.hasAttribute('data-mw-deco-blank')) {
      deco.querySelectorAll('input[type="checkbox"]').forEach(function (c) { if (c !== t) c.checked = false; });
    } else if (t.checked) {
      var blank = deco.querySelector('[data-mw-deco-blank]');
      if (blank) blank.checked = false;
      if (!t.hasAttribute('data-mw-deco-unsure')) {
        var unsure = deco.querySelector('[data-mw-deco-unsure]');
        if (unsure) unsure.checked = false;
      } else {
        deco.querySelectorAll('input[type="checkbox"]').forEach(function (c) { if (c !== t) c.checked = false; });
      }
    }
    updateQuoteTiming(deco.closest('[data-mw-quote]') || document);
  });

  /* Logo / reference file uploads (only active once an upload box is on the page). Each finished upload adds
     its link to the hidden field that goes out with the quote email. Sending waits until uploads finish. */
  var MAX_FILES = 10;
  var MAX_BYTES = 10 * 1024 * 1024;
  function fileSize(n) { return n > 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB'; }
  function uploadState(box) {
    var done = [], busy = 0;
    box.querySelectorAll('.mw-upload__item').forEach(function (li) {
      if (li.getAttribute('data-url')) done.push(li.getAttribute('data-name') + ': ' + li.getAttribute('data-url'));
      else if (li.classList.contains('is-busy')) busy++;
    });
    box.querySelector('[data-mw-upload-value]').value = done.join('\n');
    return busy;
  }
  function addFiles(box, files) {
    var list = box.querySelector('[data-mw-upload-list]');
    var msg = box.querySelector('[data-mw-upload-msg]');
    var key = box.getAttribute('data-key');
    msg.textContent = '';
    Array.prototype.forEach.call(files, function (file) {
      if (list.children.length >= MAX_FILES) { msg.textContent = 'You can add up to ' + MAX_FILES + ' files.'; return; }
      if (file.size > MAX_BYTES) { msg.textContent = file.name + ' is over 10 MB. Email it to teamsales@midwaysports.com instead.'; return; }
      var li = el('li', 'mw-upload__item is-busy');
      li.setAttribute('data-name', file.name);
      var name = el('span', 'mw-upload__name', file.name);
      var meta = el('span', 'mw-upload__meta', 'Uploading\u2026 0%');
      var bar = el('span', 'mw-upload__bar');
      var fill = el('span', 'mw-upload__fill');
      bar.appendChild(fill);
      var rm = el('button', 'mw-upload__remove', '\u00d7');
      rm.type = 'button';
      rm.setAttribute('aria-label', 'Remove ' + file.name);
      li.appendChild(name); li.appendChild(meta); li.appendChild(rm); li.appendChild(bar);
      list.appendChild(li);
      var fd = new FormData();
      fd.append('UPLOADCARE_PUB_KEY', key);
      fd.append('UPLOADCARE_STORE', '1');
      fd.append('file', file, file.name);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://upload.uploadcare.com/base/');
      xhr.upload.onprogress = function (ev) {
        if (!ev.lengthComputable) return;
        var pct = Math.round((ev.loaded / ev.total) * 100);
        fill.style.width = pct + '%';
        meta.textContent = 'Uploading\u2026 ' + pct + '%';
      };
      xhr.onload = function () {
        li.classList.remove('is-busy');
        var res = null;
        try { res = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300 && res && res.file) {
          li.setAttribute('data-url', 'https://ucarecdn.com/' + res.file + '/' + encodeURIComponent(file.name));
          li.classList.add('is-done');
          meta.textContent = fileSize(file.size) + ' \u00b7 Uploaded';
        } else {
          li.classList.add('is-error');
          meta.textContent = 'Upload failed. Remove it and try again.';
        }
        uploadState(box);
      };
      xhr.onerror = function () {
        li.classList.remove('is-busy');
        li.classList.add('is-error');
        meta.textContent = 'Upload failed. Remove it and try again.';
        uploadState(box);
      };
      rm.addEventListener('click', function () {
        if (li.classList.contains('is-busy')) xhr.abort();
        li.remove();
        uploadState(box);
      });
      xhr.send(fd);
    });
    uploadState(box);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-mw-upload-input]')) return;
    addFiles(t.closest('[data-mw-upload]'), t.files);
    t.value = '';
  });
  ['dragenter', 'dragover'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var drop = e.target.closest && e.target.closest('[data-mw-upload-drop]');
      if (!drop) return;
      e.preventDefault();
      drop.classList.add('is-over');
    });
  });
  ['dragleave', 'drop'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var drop = e.target.closest && e.target.closest('[data-mw-upload-drop]');
      if (!drop) return;
      e.preventDefault();
      drop.classList.remove('is-over');
      if (type === 'drop' && e.dataTransfer && e.dataTransfer.files.length) addFiles(drop.closest('[data-mw-upload]'), e.dataTransfer.files);
    });
  });
  document.addEventListener('submit', function (e) {
    var box = e.target.querySelector && e.target.querySelector('[data-mw-upload]');
    if (!box) return;
    if (uploadState(box) > 0) {
      e.preventDefault();
      box.querySelector('[data-mw-upload-msg]').textContent = 'Please wait for your files to finish uploading.';
    }
  }, true);

  /* Minimum order for team pricing / decoration: 20 pieces. Under that, the quote can't be sent and the
     shopper is pointed to buying blanks at regular price. */
  var MOQ = 20;
  function updateMoq(panel) {
    var qty = panel.querySelector('[data-mw-quote-qty]');
    var box = panel.querySelector('[data-mw-moq]');
    var submit = panel.querySelector('.mw-quote__form button[type="submit"]');
    if (!qty || !box) return true;
    var n = parseInt(qty.value, 10) || 0;
    var under = n > 0 && n < MOQ;
    box.hidden = !under;
    if (submit) {
      submit.disabled = under;
      submit.classList.toggle('is-blocked', under);
    }
    return !under;
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-mw-quote-qty]')) updateMoq(t.closest('[data-mw-quote]'));
  });
  document.addEventListener('submit', function (e) {
    var panel = e.target.closest && e.target.closest('[data-mw-quote]');
    if (panel && !updateMoq(panel)) e.preventDefault();
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mw-moq-shop]');
    if (!b) return;
    closeQuote();
    var bulk = document.querySelector('.mw-bulk') || document.querySelector('.product-info__variant-picker');
    if (bulk) setTimeout(function () { bulk.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 280);
  });

  function closeQuote() {
    var panel = document.querySelector('[data-mw-quote].is-open');
    if (!panel) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('mw-quote-open');
    setTimeout(function () { panel.hidden = true; }, 250);
    if (quoteLastFocus && quoteLastFocus.focus) quoteLastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var b = t.closest('[data-mw-bulk-add]');
    if (b) { bulkAdd(b.closest('[data-mw-bulk]')); return; }
    var q = t.closest('[data-mw-quote-open]');
    if (q && openQuote(q)) { e.preventDefault(); return; }
    if (t.closest('[data-mw-quote-close]')) { closeQuote(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuote(); });

  /* After the form is sent (or has an error), Shopify reloads this page: reopen the panel on the message */
  function autoOpenQuote() {
    var flag = document.querySelector('[data-mw-quote-auto-open]');
    if (!flag) return;
    var panel = flag.closest('[data-mw-quote]');
    var team = panel && document.querySelector('.mw-team[data-form="' + panel.getAttribute('data-form') + '"]');
    var trigger = team && team.querySelector('[data-mw-quote-open]');
    if (trigger) openQuote(trigger);
  }
  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      document.querySelectorAll('script[data-mw-pdp-variants]').forEach(function (s) { refresh(s.getAttribute('data-form')); });
    }, 60);
  });

  /* The old tag-based notes ("Item available online only, no in-store pickup", "ships directly from the
     manufacturer") can be wrong when a tagged item is actually in the warehouse or store. The delivery box
     now shows real River Landing stock, so hide those notes wherever the delivery box is present. */
  function hideOldNotes() {
    if (!document.querySelector('.mw-delivery')) return;
    document.querySelectorAll('.product-info__liquid').forEach(function (el) {
      var t = (el.textContent || '').toLowerCase();
      if (t.indexOf('no in-store pickup') !== -1 || t.indexOf('ships directly from the manufacturer') !== -1) el.style.display = 'none';
    });
  }

  /* Quick add panels load their content later: set those up when they appear */
  function watchQuickBuy() {
    if (!('MutationObserver' in window)) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(init, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Sticky "Add to cart" bar (the theme's product-quick-add): instead of adding whatever variant happens to be
     selected, open the quick add panel so the shopper confirms color and size. Single-variant products still
     add straight to cart. */
  var stickyDrawer = null;
  function productHandle() {
    var vp = document.querySelector('variant-picker[handle]');
    if (vp) return vp.getAttribute('handle');
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function hasRealVariants() {
    var s = document.querySelector('script[data-mw-pdp-variants]');
    if (!s) return true;
    try { return JSON.parse(s.textContent).length > 1; } catch (e) { return true; }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('product-quick-add button[type="submit"], product-quick-add [type="submit"]');
    if (!btn || !hasRealVariants()) return;
    var handle = productHandle();
    if (!handle || !window.customElements || !customElements.get('quick-buy-drawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!stickyDrawer) {
      stickyDrawer = document.createElement('quick-buy-drawer');
      stickyDrawer.id = 'mw-sticky-quick-buy';
      stickyDrawer.setAttribute('handle', handle);
      stickyDrawer.setAttribute('header-bordered', '');
      stickyDrawer.setAttribute('open-from', 'bottom');
      stickyDrawer.setAttribute('role', 'region');
      stickyDrawer.setAttribute('aria-live', 'polite');
      stickyDrawer.className = 'quick-buy-drawer drawer';
      document.body.appendChild(stickyDrawer);
    }
    stickyDrawer.show();
  }, true);

  function start() { init(); hideOldNotes(); autoOpenQuote(); watchQuickBuy(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
